import React from "react";
import {Switch} from "react-router-dom";
import CustomRoute from "../../../hoc/CustomRoute";

function Offres(props) {



    return (
        <Switch>
            {props.routes.map(route => {
                return CustomRoute(route);
            })}
        </Switch>
    );

}

export default Offres;